export const legendDataSource = [
	'<Account>',
	'<Agent>',
	'<Asset>',
	'<CategoryNode>',
	'<CategoryPath>',
	'<Instance>',
	'<MetricId>',
	'<MetricType>',
	'<RegistryIdentifier>',
	'<RegistryOwnerId>',
	'<RegistryType>',
	'<Source>',
	'<Timezone>',
	'<Unit>',
] as const;

export const legendOptions = legendDataSource.map((x) => ({
	label: x,
	value: x,
}));

export const legendDefaultValue = ['<Asset>', '<Instance>'] as const;
